'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import ModalComponent from 'components/common/ModalComponent'
import { showAlert } from 'services/alerts.service'

const GroupOptionsModal = ({ isOpen, handleClose, selectedGroup, handleSave }) => {
  const { t } = useTranslation()
  const handleGroupSave = formData => {
    if (!formData.groupName || formData.groupName.trim() === '') {
      showAlert({
        text: t('mgmt.groups.nameRequired'),
        icon: 'warning'
      })
      return
    }

    const dataToSave = selectedGroup?.groupId
      ? { ...formData, groupId: selectedGroup.groupId }
      : { ...formData, groupId: undefined }

    handleSave(dataToSave)
    handleClose()
  }

  return (
    <ModalComponent
      title={selectedGroup?.groupId ? t('mgmt.groups.updateTitle') : t('mgmt.groups.createTitle')}
      isOpen={isOpen}
      onClose={handleClose}
      initialData={{
        groupId: selectedGroup?.groupId || '',
        groupName: selectedGroup?.groupName || ''
      }}
      onSave={handleGroupSave}
    >
      {({ formData, handleChange }) => (
        <div className='space-y-4 w-96'>
          <label className='block text-sm font-medium'>
            {t('mgmt.groups.groupName')} *
            <input
              type='text'
              name='groupName'
              value={formData.groupName}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            />
          </label>
        </div>
      )}
    </ModalComponent>
  )
}

export default GroupOptionsModal
